var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea-wrap"},[_c('textarea',{ref:"lczdTxt",staticClass:"reply-text",attrs:{"placeholder":_vm.placeholder,"maxlength":_vm.limit > 0 ? _vm.limit : 999},domProps:{"value":_vm.value},on:{"input":_vm.onChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }